import { __assign } from "tslib";
import { useEffect } from 'react';
import { TrackApiError, TrackApiNoResponse, TrackApiSuccess, TrackApiNotValid, } from './TrackingFunctions';
import { getByIdentifier } from './utils';
function handleApiResponse(_a) {
    var screen = _a.screen, version = _a.version, projectKey = _a.projectKey, apiError = _a.apiError, apiIsLoading = _a.apiIsLoading, apiItems = _a.apiItems, apiItemsInvalid = _a.apiItemsInvalid, ratAccountId = _a.ratAccountId, ratServiceType = _a.ratServiceType, ratServiceId = _a.ratServiceId, isMobile = _a.isMobile, userId = _a.userId, sessionId = _a.sessionId, clientId = _a.clientId, _b = _a.isRatCoreEventsOnly, isRatCoreEventsOnly = _b === void 0 ? false : _b, ratApiAccountSrc = _a.ratApiAccountSrc, _c = _a.isPreview, isPreview = _c === void 0 ? false : _c;
    if (apiIsLoading === true) {
        return null;
    }
    var apiTrackingBaseParameters = {
        screen: screen,
        version: version,
        projectKey: projectKey,
        ratAccountId: ratAccountId,
        ratServiceType: ratServiceType,
        ratServiceId: ratServiceId,
        isMobile: isMobile,
        userId: userId,
        sessionId: sessionId,
        clientId: clientId,
        ratApiAccountSrc: ratApiAccountSrc,
        isRatCoreEventsOnly: isRatCoreEventsOnly,
        isPreview: isPreview,
    };
    if (apiError) {
        return TrackApiError(__assign(__assign({}, apiTrackingBaseParameters), { error: apiError }));
    }
    if (apiItemsInvalid.length > 0) {
        return TrackApiNotValid(__assign({ data: apiItemsInvalid }, apiTrackingBaseParameters));
    }
    if (!apiItems || apiItems.length < 1) {
        return TrackApiNoResponse(__assign({}, apiTrackingBaseParameters));
    }
    return TrackApiSuccess(__assign(__assign({}, apiTrackingBaseParameters), { data: apiItems, campaignId: getByIdentifier('campaignId', apiItems), contentId: getByIdentifier('contentId', apiItems) }));
}
export function useSendApiTrackingToRat(_a) {
    var screen = _a.screen, apiError = _a.apiError, apiIsLoading = _a.apiIsLoading, apiItems = _a.apiItems, apiItemsInvalid = _a.apiItemsInvalid, version = _a.version, projectKey = _a.projectKey, ratAccountId = _a.ratAccountId, ratServiceType = _a.ratServiceType, ratServiceId = _a.ratServiceId, isMobile = _a.isMobile, userId = _a.userId, sessionId = _a.sessionId, clientId = _a.clientId, _b = _a.isRatCoreEventsOnly, isRatCoreEventsOnly = _b === void 0 ? false : _b, ratApiAccountSrc = _a.ratApiAccountSrc, _c = _a.isPreview, isPreview = _c === void 0 ? false : _c;
    useEffect(function () {
        handleApiResponse({
            screen: screen,
            apiError: apiError,
            apiIsLoading: apiIsLoading,
            apiItems: apiItems,
            apiItemsInvalid: apiItemsInvalid,
            version: version,
            projectKey: projectKey,
            ratAccountId: ratAccountId,
            ratServiceType: ratServiceType,
            ratServiceId: ratServiceId,
            isMobile: isMobile,
            userId: userId,
            sessionId: sessionId,
            clientId: clientId,
            isRatCoreEventsOnly: isRatCoreEventsOnly,
            ratApiAccountSrc: ratApiAccountSrc,
            isPreview: isPreview,
        });
    }, [apiError, apiIsLoading, apiItems, apiItemsInvalid]);
}
